<template>
  <div class="root">
    <div v-if="!$root.loaded" class="loading">
      <h1>Loading</h1>
      <img src="../assets/loading.gif" alt="">
    </div>
    <div v-else class="kit-compare">
      <div class="kit-navigation">
        <a class="back-button" @click="$router.go(-1)"> Back </a>
      </div>
      <div class="kit-compare-wrapper">
        <h1> Kit Comparisons </h1>
        <div class="kit-results compare" :class="kits.length === 3 ? 'three' : 'two'">
            <template v-for="filteredKit in kits">
              <div :key="filteredKit.id" class="kit-grid summary">
              <div class="kit-result-title">
                <h4>{{ filteredKit.name }}</h4>
              </div>
              <ul>
                <li class="links" v-if="filteredKit.website">
                  <a :href="filteredKit.website.trim()" target="_blank" @click.stop>Website</a>
                </li>
                <li class="links">
                  <a v-if="filteredKit.instructions" :href="filteredKit.instructions.trim()" target="_blank" @click.stop>Instructions</a>
                  <a v-else :href="filteredKit.website.trim()" target="_blank" @click.stop>Please Contact {{filteredKit.distributorInfo.name}} for Instructions</a>
                </li>
                <li v-if="filteredKit.turnaroundTime">
                  <span class="kit-properties-key">Turn Around:</span> {{ filteredKit.turnaroundTime }}
                </li>
                <li v-if="filteredKit.kitValidationStandards">
                  <span v-for="standard in filteredKit.kitValidationStandards" :key="standard.id">
                    <span class="kit-properties-key">Kit Validation:</span> {{ standard.name }}
                  </span>
                </li>
                <li v-if="filteredKit.detectionLimits">
                  <span class="kit-properties-key">Detection Limits:</span> {{filteredKit.detectionLimits[0].name}}
                </li>
                <li v-if="filteredKit.easeOfUse">
                  <span class="kit-properties-key">Ease of Use:</span>
                  <span> {{$root.easeOfUseDescriptors[filteredKit.easeOfUse - 1].rating}}</span>
                  <ul>
                    <li>Descriptor to evaluate include; {{$root.easeOfUseDescriptors[filteredKit.easeOfUse - 1].description}}</li></ul>
                </li>
                <li v-if="filteredKit.levelOfTraining">
                  <span class="kit-properties-key">Level of Training:</span>
                  <span> {{$root.levelOfTrainingDescriptors[filteredKit.levelOfTraining - 1].rating}}</span>
                  <ul><li>Recommended level of training; {{$root.levelOfTrainingDescriptors[filteredKit.levelOfTraining - 1].description}}</li></ul>
                </li>
              </ul>
              </div>
            </template>
            <template v-for="filteredKit in kits">
              <div class="kit-grid distributor" :key="filteredKit.id + 1">
                <div class="kit-details-block">
                  <h4> Distributor Information </h4>
                  <div class="filteredKit-details-info">
                    <p>{{ filteredKit.distributorInfo.name }}</p>
                    <p>
                      <span v-for="(country, index) in filteredKit.distributorInfo.country" :key="index">
                        {{ country }}<span v-if="index !== filteredKit.distributorInfo.country.length - 1">,</span>
                      </span>
                    </p>
                    <p v-for="(website, index) in filteredKit.distributorInfo.website" :key="index">
                      <a v-if="index === 0" :href="website.trim()" target="_blank" @click.stop>Visit Distributor Website</a>
                      <a v-else :href="website.trim()" target="_blank" @click.stop>Visit Alternate Distributor Website
                        <span v-if="filteredKit.distributorInfo.website.length > 2">{{index}}</span>
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </template>
            <template v-for="(value, index) in kits[0]">
              <template v-for="(filteredKit,kitIndex) in kits">
                  <div v-if="checkProperty(index)" :key="filteredKit.id + index" :class="`kit-grid info ${ kitIndex % kits.length === 0 ? '': 'border-left'}`">
                  <div class="kit-details-block" >
                    <h4 class="kit-properties-key"> {{ formatIndex(index) }}: </h4>
                    <span class="kit-details-info"> {{ formatValue(filteredKit[index]) }} </span>
                  </div>
                  </div>
              </template>
            </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixins from '../mixins/mixins.vue'
export default {
  name: 'KitCompare',
  mixins: [mixins],
  data () {
    return {
      kitIDs: this.$route.query.kits.split('-')
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
    kits () {
      if (this.$root.loaded) {
        var lcKits = []
        this.kitIDs.forEach(id => {
          var currentKit = this.$root.kits.find(kit => kit.id === id)
          if (currentKit !== undefined) {
            lcKits.push(currentKit)
          }
        })
      }
      return lcKits
    }
  }
}
</script>
